import React, { useCallback } from 'react';
import { ButtonItem } from '@atlaskit/menu';
import { useIntl } from '@atlassian/jira-intl';
import { useIsFullscreen } from '@atlassian/jira-layout-controller/src/controllers/layout-controller/consumers/fullscreen';
import { ShortcutLabel } from '@atlassian/jira-shortcut-label';
import type { MenuItemProps } from '../types';
import messages from './messages';

export const FullscreenItem = ({ onClosePopup }: MenuItemProps) => {
	const { formatMessage } = useIntl();
	const [isFullscreen, { setIsFullscreen }] = useIsFullscreen();

	const toggleFullscreen = useCallback(() => {
		setIsFullscreen(!isFullscreen);
		onClosePopup && onClosePopup();
	}, [isFullscreen, setIsFullscreen, onClosePopup]);

	return (
		<ButtonItem
			iconAfter={<ShortcutLabel text="Z" />}
			onClick={toggleFullscreen}
			aria-keyshortcuts="Z"
		>
			{isFullscreen
				? formatMessage(messages.exitFullScreen)
				: formatMessage(messages.enterFullScreen)}
		</ButtonItem>
	);
};
